module.exports = __webpack_public_path__ + "img/ORIGAMI_GRAPE.3a3ed6a9.png";